import { Loader2 } from "lucide-react";

/** Suspense fallback for lazily-loaded route chunks. */
export function RouteFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loader2 className="text-muted h-6 w-6 animate-spin" />
    </div>
  );
}
